export function formatPhoneDisplay(value) {
  let digits = String(value || '').replace(/\D/g, '');
  if (digits.length > 10) digits = digits.slice(0, 10);
  if (digits.length > 6) return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  if (digits.length > 3) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return digits;
}

export function toE164ish(value) {
  const raw = String(value || '').trim();
  if (raw.startsWith('+')) {
    const digits = raw.replace(/[^\d+]/g, '');
    return digits;
  }
  let digits = raw.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }
  if (digits.length === 10) {
    return `+1${digits}`;
  }
  return digits ? `+${digits}` : '';
}

export function validateLead(raw) {
  const errors = [];
  const firstName = String(raw.firstName || '').trim();
  const lastName = String(raw.lastName || '').trim();
  const email = String(raw.email || '').trim();
  const phone = String(raw.phone || '').trim();

  if (!firstName) errors.push({ field: 'firstName', message: 'Enter your first name.' });
  if (!lastName) errors.push({ field: 'lastName', message: 'Enter your last name.' });
  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.push({ field: 'email', message: 'Enter a valid email address.' });
  }
  const digits = phone.replace(/\D/g, '');
  if (!phone || digits.length < 10) {
    errors.push({ field: 'phone', message: 'Enter a phone number with at least 10 digits.' });
  }
  if (!raw.isRealtor) {
    errors.push({ field: 'firstName', message: 'Select whether you are a realtor.' });
  }
  if (raw.isRealtor === 'yes' && !String(raw.brokerage || '').trim()) {
    errors.push({ field: 'brokerage', message: 'Enter your brokerage or company.' });
  }
  if (!raw.productInterest) {
    errors.push({ field: 'productInterest', message: 'Select a product interest.' });
  }
  if (!raw.buyerType) {
    errors.push({ field: 'buyerType', message: 'Select what best describes you.' });
  }
  if (raw.marketingConsent !== 'yes') {
    errors.push({ field: 'firstName', message: 'Marketing consent is required to register.' });
  }
  return errors;
}
